import React from "react";
import InnerPageTitle from "../Helpers/InnerPageTitle";
import FooterOne from "../Layouts/Footers/FooterOne";
import MainWid from "./MainWid";
import HeaderOne from "../Layouts/Headers/HeaderOne";
import { useTranslation } from "react-i18next";

function Product() {
  const { t, i18n } = useTranslation("products");
  const currentLanguage = i18n.language;

  return (
    <>
      <HeaderOne />
      <InnerPageTitle
        title={t("products")}
        paths={[
          { name: t("home"), path: `/${currentLanguage}/` },
          { name: t("products"), path: `/${currentLanguage}/products` },
        ]}
      />
      <MainWid />
      <FooterOne />
    </>
  );
}

export default Product;
